import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";
import DownloadByLabel from "../components/Download/DownloadByLabel";

const AgmFilesJune2024 = () => {
  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center">
            ملفات الجمعية العمومية العادية يونيو 2024
          </h1>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              محصر اجتماع الجمعية العمومية
            </h2>

            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              التقرير الإداري
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/AdministrativeReport-2023.pdf"}
              name={`AdministrativeReport-2023`}
              label={"AdministrativeReport-2023.pdf"}
            />

            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              مشروع الموازنة التقديرية{" "}
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/EstimatedBudget2024.pdf"}
              name={`EstimatedBudget2024`}
              label={"EstimatedBudget2024.pdf"}
            />

            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              القوائم المالية
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/FinancialReport2023.pdf"}
              name={`FinancialReport2023`}
              label={"FinancialReport2023.pdf"}
            />

            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              التقرير المالي
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/Viewfinancialreport2023.pdf"}
              name={`Viewfinancialreport2023`}
              label={"Viewfinancialreport2023.pdf"}
            />

            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              الخطة الاستراتيجية
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/StrategicPlan.pdf"}
              name={`StrategicPlan`}
              label={"StrategicPlan.pdf"}
            />

            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              الخطة التشغيلية
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/Operationalplan2024.pdf"}
              name={`Operationalplan2024`}
              label={"Operationalplan2024.pdf"}
            />
            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              كشف حضور الجمعية العموية
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/AttendanceSheet2024.pdf"}
              name={`AttendanceSheet2024`}
              label={"AttendanceSheet2024.pdf"}
            />
            <h3 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              مقترح انشاء جمعية تخصصية
            </h3>
            <DownloadByLabel
              url={"images/general-assembly/EstablishingAssociations.pdf"}
              name={`EstablishingAssociations`}
              label={"EstablishingAssociations.pdf"}
            />
            {/* محصر اجتماع الجمعية العمومية */}
            <div className="mt-6 md:mt-10 mb-2 md:mb-4">
              <DownloadByLabel
                url={"images/general-assembly/meeting_27-06-2024.pdf"}
                name={`محصر اجتماع الجمعية العمومية"`}
                label={"محصر اجتماع الجمعية العمومية"}
              />
            </div>
          </div>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default AgmFilesJune2024;
